var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBCoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 14C23.5 19.2467 19.2467 23.5 14 23.5C8.75329 23.5 4.5 19.2467 4.5 14C4.5 8.75329 8.75329 4.5 14 4.5C19.2467 4.5 23.5 8.75329 23.5 14Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C6.54415 27.5 0.5 21.4558 0.5 14C0.5 6.54416 6.54415 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4366 10.3433C11.4366 10.9471 10.9471 11.4366 10.3433 11.4366C9.73948 11.4366 9.25 10.9471 9.25 10.3433C9.25 9.73948 9.73948 9.25 10.3433 9.25C10.9471 9.25 11.4366 9.73948 11.4366 10.3433Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1866 10.3433C15.1866 10.9471 14.6971 11.4366 14.0933 11.4366C13.4895 11.4366 13 10.9471 13 10.3433C13 9.73948 13.4895 9.25 14.0933 9.25C14.6971 9.25 15.1866 9.73948 15.1866 10.3433Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9066 14.0034C18.9066 14.6073 18.4171 15.0967 17.8133 15.0967C17.2095 15.0967 16.72 14.6073 16.72 14.0034C16.72 13.3996 17.2095 12.9102 17.8133 12.9102C18.4171 12.9102 18.9066 13.3996 18.9066 14.0034Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6866 14.0015C11.6866 14.7434 11.0852 15.3448 10.3433 15.3448C9.60141 15.3448 9 14.7434 9 14.0015C9 13.2596 9.60141 12.6582 10.3433 12.6582C11.0852 12.6582 11.6866 13.2596 11.6866 14.0015Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.425 14.0015C15.425 14.7434 14.8236 15.3448 14.0817 15.3448C13.3398 15.3448 12.7384 14.7434 12.7384 14.0015C12.7384 13.2596 13.3398 12.6582 14.0817 12.6582C14.8236 12.6582 15.425 13.2596 15.425 14.0015Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1578 10.3433C19.1578 11.0852 18.5564 11.6866 17.8145 11.6866C17.0726 11.6866 16.4712 11.0852 16.4712 10.3433C16.4712 9.60141 17.0726 9 17.8145 9C18.5564 9 19.1578 9.60141 19.1578 10.3433Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6866 17.6558C11.6866 18.3977 11.0852 18.9991 10.3433 18.9991C9.60141 18.9991 9 18.3977 9 17.6558C9 16.9139 9.60141 16.3125 10.3433 16.3125C11.0852 16.3125 11.6866 16.9139 11.6866 17.6558Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.425 17.6558C15.425 18.3977 14.8236 18.9991 14.0817 18.9991C13.3398 18.9991 12.7384 18.3977 12.7384 17.6558C12.7384 16.9139 13.3398 16.3125 14.0817 16.3125C14.8236 16.3125 15.425 16.9139 15.425 17.6558Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1634 17.6558C19.1634 18.3977 18.562 18.9991 17.8201 18.9991C17.0782 18.9991 16.4768 18.3977 16.4768 17.6558C16.4768 16.9139 17.0782 16.3125 17.8201 16.3125C18.562 16.3125 19.1634 16.9139 19.1634 17.6558Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCoinIcon);
export default __webpack_public_path__ + "static/media/BCoinIcon.71b8749d594cb7fbe443338434bda201.svg";
export { ForwardRef as ReactComponent };